export default "__VITE_ASSET__FKNdLzKnlftW3t_gzo81yw__$_?url=true&w=1200&format=jpg&quality=80__"